/**
 * Created by wajidafaneh on 29/01/2017.
 */
import {PENALTY_EXCEPTIONS_TYPES} from "../../constants/ct-timesheet-penalty-exceptions.constants.js";
import {ACTUAL_CLOCK_ACTION_VIOLATION_TYPE} from "../../../../../../hmodules/shared-clock-time/constants/actual-clock-time-management.constants.js";

(function (angular) {

    "use strict";

    angular
        .module('harriApp')
        .controller('CTEditShiftModalController', [
            "$scope",
            "$filter",
            "CTTimesheetService",
            "TeamScheduleService",
            "modalData", "onSave",
            "onReload",
            "TSUsersService",
            "userPermissions",
            "userServices",
            "TimesheetSettingsService",
            "businessDayUtils",
            "fairSchedulingService",
            "hUser",
            "ShiftTemplateUtils",
            "brandServices",
            "$modal",
            "actualClockTimeManagementService",
            "jobTitlesDataService",
            "useIncentiveOpenShiftPaymentFactory",
            function (
                $scope,
                $filter,
                CTTimesheetService,
                TeamScheduleService,
                modalData,
                onSave,
                onReload,
                TSUsersService,
                userPermissions,
                userServices,
                TimesheetSettingsService,
                businessDayUtils,
                fairSchedulingService,
                hUser,
                ShiftTemplateUtils,
                brandServices,
                $modal,
                actualClockTimeManagementService,
                jobTitlesDataService,
                useIncentiveOpenShiftPaymentFactory,
            ) {

            $scope.activeTab = modalData.activeTab || 'DETAILS';
            $scope.shift = modalData.shift;
            $scope.date = moment($filter("formatDateIgnoreTimeZone")(modalData.shift.date, "YYYY-MM-DD"));
            var formattedShiftDate = $scope.date.format('YYYY-MM-DD');
            $scope.breaksRulesSet = CTTimesheetService.getBreaksRulesSet(formattedShiftDate);
            $scope.clockTimeStatusReasonTrackingMode = CTTimesheetService.getClockTimeStatusReasonTrackingMode($scope.date);
            $scope.employee = modalData.employee;
            $scope.clockLoginSettings = modalData.clockLoginSettings;
            $scope.facialRecognitionEnabled = false;
            $scope.hasTimesheetOfflineConflict = modalData.shift && modalData.shift.has_timesheet_offline_conflict;
            $scope.isThereRecordsHiddenDueOffline = false;
            $scope.PENALTY_TYPES = PENALTY_EXCEPTIONS_TYPES;
            $scope.isProcessing = false;
            $scope.error = null;
            $scope.showPunchPhoto = false;
            $scope.warningtext = '';
            var selectedWeekLockStatus;

            $scope.onTimeChangeValidate = function (target) {
                return function (value) {
                    if (value && value.isValid()) {
                        if (value.isBefore(clockTimeMoment['clockIn'])) {
                            value.add(1, 'day');
                        }
                        if (value.isAfter(clockTimeMoment['clockOut'])) {
                            value.subtract(1, 'day');
                        }
                        if (target == 'from') {
                            if (value.isAfter(clockTimeMoment['clockOut'])) {
                                value = clockTimeMoment['clockIn'];
                            }
                        } else if (target == 'to') {
                            if (value.isBefore(clockTimeMoment['clockIn'])) {
                                value = clockTimeMoment['clockOut'];
                            }
                        }
                    }
                    return value;
                }
            };

            $scope.changePunchPhoto = function (close, employeeAttempt) {
                if (close) {
                    $scope.showPunchPhoto = false;
                } else if (employeeAttempt.is_employee_ignored) {
                    return;
                } else {
                    $scope.showPunchPhoto = false;
                    $scope.showPunchPhoto = !$scope.showPunchPhoto;
                    $scope.punchPhoto = employeeAttempt;
                }
            };

            $scope.actionsMap = RecognitionAPI.RECOGNITION_ACTIONS;
            $scope.recognitionStatus = RecognitionAPI.RECOGNITION_STATUS;

            $scope.historyEntries = [];

            modalData.date = $scope.date.format("YYYY-MM-DD");
            modalData.timeSheeetAdjustmentSettings = CTTimesheetService.getTimeSheetAdjusmentsSettings();
            $scope.activeCallInsSettings = CTTimesheetService.getCallInsSettings( modalData.date);
            $scope.timeSheeetAdjustmentSettings = modalData.timeSheeetAdjustmentSettings;
            $scope.isTCAFLiteEnabled = $scope.timeSheeetAdjustmentSettings.tcaf_mode === 'LITE';

            if ($scope.timeSheeetAdjustmentSettings.is_clock_edit_reason_enabled) {
                $scope.EditCardReasons = CTTimesheetService.getBrandEditTimeCardReasons();
            }

            if (!$scope.employee.isDateWithinActiveLocationPeriod($scope.date)) {
                $scope.shift.is_editable = false;
                $scope.warningtext += $filter("translate")('You can’t restore a shift out of active location period') + '<br>';
                $scope.error = "OUT_OF_LOCATION_PERIOD";

                var latestLocationPeriod = $scope.employee.getLatestLocationPeriod();


                if (latestLocationPeriod) {
                    var formattedDate = moment($scope.date).format("YYYY-MM-DD");

                    if (
                        latestLocationPeriod.start_date &&
                        moment(formattedDate).isBefore(latestLocationPeriod.start_date, 'day')
                    ) {
                        $scope.activeLocationPeriodStartDate = latestLocationPeriod.start_date;
                    } else {
                        $scope.activeLocationPeriodEndDate = latestLocationPeriod.end_date;
                    }
                }
            }

            if (!$scope.employee.isDateWithinEmploymentPeriod($scope.date)) {
                $scope.shift.is_editable = false;
                $scope.shift.is_tips_editable = false;
                $scope.warningtext += $filter("translate")('You can’t restore a shift out of employment period') + '<br>';
                $scope.error = "OUT_OF_EMPLOYMENT_PERIOD";
            }

            if ($scope.employee.hasEffectiveLOA($scope.date)) {
                $scope.warningtext += $filter("translate")('Unable to restore timecard as ') + $scope.employee.first_name+ ' ' + $scope.employee.last_name + $filter("translate")(' is on leave of absence');
                $scope.error = "IN_ACTIVE_LOA_PERIOD";
            }

            $scope.isViewOnly = function () {
                return $scope.shift.isViewOnly;
            };

            $scope.editShiftForm = new CTManageShiftForm(
                $scope,
                $filter,
                CTTimesheetService,
                TeamScheduleService,
                modalData,
                userPermissions,
                userServices,
                TimesheetSettingsService,
                businessDayUtils,
                TSUsersService,
                hUser,
                ShiftTemplateUtils,
                brandServices,
                actualClockTimeManagementService,
                jobTitlesDataService,
                useIncentiveOpenShiftPaymentFactory,
            );

            $scope.editShiftForm.onOverlappingBreaks (function (numberOfOverlappingBreaks) {
                $scope.isThereOverlapping = !!numberOfOverlappingBreaks;
            });

            var clockTimeMoment;

            var parseHistory = function (data) {
                data = data || [];
                var isScheduledShift = !!$scope.shift.scheduled_shift;
                const breaksHistoryTextVersionSettings = modalData.breaksHistoryTextVersionSettings;

                var allHistoryEntries = data.map((entry) => {

                    if (entry.source) {
                        var source;
                        if (entry.source === 'PUNCH'){
                            var platform = (entry.platform === 'ANDROID' || entry.platform === 'IOS')? '(App)': '(Web)';
                            source = 'Punch Mgmt ' +platform;
                        } else {
                            source = entry.source === 'TEAMHUB'? 'TeamHub': 'Time Sheet';

                        }
                        entry.sourceDisplay = $filter('translate')(source);
                    }

                    if (entry.clock_edit_reason) {
                        var newAttribute = {
                            action: 'SET',
                            attribute: 'edit_card_reason',
                            to: entry.clock_edit_reason.reason
                        };

                        entry.attributes.push(newAttribute);
                    }

                    if (entry.actor) {
                        entry.actor.typeInitial = entry.actor.type === 'EMPLOYER'? 'M': (entry.actor.type === 'EMPLOYEE'? 'E': 'S');
                        if (entry.actor.type === 'SYSTEM') {
                            entry.actor.name = 'System Auto';
                        }
                    }

                    var attributes = [];

                    for (var i in entry.attributes) {
                        var attribute = entry.attributes[i];

                        if(['OFFLINE-SYNC', 'OFFLINE-CONFLICT-RESOLVER'].indexOf(attribute.type) > -1) {
                            entry.sourceDisplay = "TH Offline";
                            $scope.isThereRecordsHiddenDueOffline = true;
                        }
                        if (attribute.attribute === 'actual_clock' &&
                            attribute.action === 'ADD' &&
                            attribute.meta &&
                            attribute.meta.call_in &&
                            attribute.meta.call_in.duration > 0 &&
                            attribute.meta.call_in.status === 'SYSTEM_APPROVED') {

                            attributes.push({
                                attribute : 'actual_clock.call_in.status',
                                from: null,
                                to: 'SYSTEM_APPROVED'
                            });
                        }

                        if (attribute.attribute === 'actual_clock.penalties.ignore_reason_id') {
                            var lastAttribute = entry.attributes[parseInt(i) - 1] || {};
                            if (lastAttribute.attribute === 'actual_clock.penalties.status'){
                                continue;
                            }
                        }

                        if (["actual_clock.right_to_rest",
                            "actual_clock.right_to_rest.status",
                            "actual_clock.right_to_rest.duration",
                            "actual_clock.right_to_rest.ignore_reason_id"
                        ].indexOf(attribute.attribute) > -1 &&
                            attribute.action === 'UPDATE' &&
                            attribute.meta.status !== "PENDING_APPROVAL") {
                            attribute.meta.clock_id = $scope.shift.actual_clock && $scope.shift.actual_clock.id;
                            attribute.meta.shift_id = $scope.shift.scheduled_shift && $scope.shift.scheduled_shift.id;
                            attribute.meta.employee_id = $scope.employee.id;
                        }

                        if (attribute.attribute === 'actual_clock.clock_in_action.reason') {
                            var nextAttribute = entry.attributes[parseInt(i) + 1] || {};
                            if (nextAttribute.attribute === 'actual_clock.clock_in_action.source' && nextAttribute.from === 'SYSTEM') {
                                attribute.from_system = " " + $filter('translate')('as system resolution');
                                nextAttribute.handled = true;
                            }
                        }

                        if (attribute.attribute === 'actual_clock.category' && (attribute.from === 'NO_SHOW' || attribute.to === 'NO_SHOW')) {
                            var nextAttribute = entry.attributes[parseInt(i) + 1] || {};

                            if (nextAttribute.attribute === 'actual_clock.sick_leave') {
                                nextAttribute = entry.attributes[parseInt(i) + 2] || {};
                            }

                            if (nextAttribute.attribute === 'actual_clock.error_reason.id') {
                                if (!nextAttribute.to) {
                                    attribute.from_reason = nextAttribute.from;
                                } else {
                                    attribute.to_reason = nextAttribute.to;
                                }

                                nextAttribute.handled = true;
                            }
                        }

                        if (attribute.attribute === "actual_clock.breaks.type" && attribute.action === 'UPDATE') {
                            if (!attribute.from.includes('UNSCHEDULED') && attribute.to.includes('UNSCHEDULED')) {
                                var originalMeta = angular.copy(attribute.meta);
                                originalMeta.type = attribute.from;

                                attributes.push({
                                    attribute : 'actual_clock.breaks.type',
                                    action: "REMOVED_FROM_ALLOWED",
                                    meta: originalMeta,
                                });
                                attributes.push({
                                    attribute : 'actual_clock.breaks.type',
                                    action: "ADDED_TO_ADDITIONAL",
                                    meta: attribute.meta,
                                });
                            }
                            else if (attribute.from.includes('UNSCHEDULED') && attribute.to.includes('UNSCHEDULED')) {
                                attributes.push({
                                    attribute : 'actual_clock.breaks.type',
                                    action: "BREAK_TYPE_CHANGED",
                                    from: attribute.from,
                                    to: attribute.to,
                                    meta: attribute.meta,
                                });
                            }
                            continue;
                        }

                        if (attribute.attribute === "actual_clock.breaks.end") {

                            if (attribute.action === 'UPDATE') {

                                if (attribute.meta && attribute.meta.id.includes('part') && !attribute.handled) {
                                    var breakUpdateAttribute = {
                                        attribute: 'actual_clock.breaks.end',
                                        action: 'UPDATE',
                                        meta : attribute.meta.original_break,
                                        to: attribute.to,
                                    };
                                    var lastAttribute = entry.attributes[parseInt(i) - 1] || {};
                                    if (lastAttribute.attribute === 'actual_clock.breaks.status' && lastAttribute.from === 'EMPLOYER_DELETED'){
                                        breakUpdateAttribute.from = attribute.meta.start_time;
                                    } else {
                                        breakUpdateAttribute.from = attribute.from;
                                    }
                                    attributes.push(breakUpdateAttribute);
                                    continue;
                                }

                                var splittedBreak = entry.attributes.find(function (attr) {
                                    var originalBreak = (attr.meta && attr.meta.original_break) || {};
                                    return attr.attribute !=='actual_clock.breaks.status' &&
                                        originalBreak.id === (attribute.meta && attribute.meta.id);
                                });

                                if (!splittedBreak) {
                                    splittedBreak = entry.attributes.find(function (attr) {
                                        var originalBreak = (attr.meta && attr.meta.original_break) || {};
                                        return attr.attribute ==='actual_clock.breaks.status' &&
                                            originalBreak.id === (attribute.meta && attribute.meta.id);
                                    });
                                }

                                if (splittedBreak) {

                                    splittedBreak.handled = true;

                                    if (splittedBreak.attribute === 'actual_clock.breaks.start') {
                                        continue;
                                    }

                                    if (splittedBreak.action === 'DELETE'){

                                        if (attribute.to === splittedBreak.meta['end_time']) {
                                            continue;
                                        }
                                        attribute.from = splittedBreak.meta['end_time'];

                                    } else {

                                        if (attribute.from === splittedBreak.meta['end_time']) {
                                            continue;
                                        }
                                        attribute.to = splittedBreak.meta['end_time'];
                                    }

                                }

                            } else if (attribute.action === 'ADD') {
                                var lastAttribute = entry.attributes[parseInt(i) - 1] || {};
                                if (lastAttribute.attribute === 'actual_clock.breaks.start') {
                                    continue;
                                }
                            }
                        }

                        if (attribute.attribute === "actual_clock.breaks") {
                            if(attribute.action === 'ADD') {
                                var missedBreak = !(attribute.meta.start_time && attribute.meta.end_time);
                                var originalBreak = attribute.meta.original_break || {};
                                if (originalBreak.id) {
                                    var lastAttribute = entry.attributes[parseInt(i) - 1] || {};
                                    if (!(lastAttribute.meta && lastAttribute.meta.id && lastAttribute.meta.id === originalBreak.id)) {
                                        attributes.push({
                                            attribute: 'actual_clock.breaks.end',
                                            action: 'UPDATE',
                                            meta : originalBreak,
                                            from: attribute.meta.start_time,
                                            to: attribute.meta.end_time,
                                        });
                                    }
                                    continue;
                                } else if (missedBreak && attribute.meta && ['EMPLOYER_ADDED', 'AUTOMATIC_ADD_TO_PAID_TIME', 'EMPLOYER_IGNORE', 'AUTOMATICALLY_IGNORED', 'PENALTY_EMPLOYER_ADDED', 'EMPLOYER_CONSUMED'].indexOf(attribute.meta.status) > -1) {
                                    attributes.push({
                                        attribute: 'actual_clock.breaks.status',
                                        action: 'UPDATE',
                                        meta: attribute.meta,
                                        to: attribute.meta.status,
                                    });
                                    continue;
                                }
                            } else if (attribute.action === 'DELETE' && !attribute.handled) {
                                var lastAttribute = entry.attributes[parseInt(i) - 1] || {};

                                if (lastAttribute.attribute === 'actual_clock.breaks.end') {
                                    continue;
                                }

                                var breakId = attribute.meta && attribute.meta.id;
                                var originalBreak = attribute.meta && attribute.meta.original_break || {};

                                if (originalBreak.id && breakId.includes('part')) {
                                    attributes.push({
                                        attribute: 'actual_clock.breaks.end',
                                        action: 'UPDATE',
                                        meta : originalBreak,
                                        from: attribute.meta.end_time,
                                        to: originalBreak.end_time,
                                    });
                                    continue;
                                }
                            }
                        }

                        if ((attribute.attribute === 'actual_clock.clock_in' || attribute.attribute === 'actual_clock.clock_out') && entry.source === 'PUNCH') {
                            attribute.action = 'UPDATE';
                        }

                        if (attribute.attribute === "actual_clock" && attribute.action === 'ADD') {
                            if (entry.source === 'PUNCH') {
                                attribute.handled = true;
                            }

                            if (attribute.meta && attribute.meta.category) {
                                attribute.type = attribute.meta.category;
                                if (attribute.meta.error_reason) {
                                    attribute.error_reason = attribute.meta.error_reason;
                                }
                            }
                        }

                        if (!attribute.handled) {
                            attributes.push(attribute);
                        }

                        if (
                            attribute.attribute === 'actual_clock.breaks.status' &&
                            attribute.meta && attribute.meta.employer_ignore_reason &&
                            attribute.meta.employer_ignore_reason.code === 'PERSONAL'
                        ) {
                            attributes.push({
                                attribute: 'actual_clock.breaks.status_reason',
                                action: 'ADD',
                                to: attribute.meta.employer_ignore_reason.code,
                                meta : attribute.meta
                            })
                        }

                        if (attribute.attribute === "actual_clock" && attribute.action === 'ADD') {

                            if (attribute.meta && attribute.meta.clock_in) {
                                var action = entry.source === 'PUNCH'? 'UPDATE' : 'ADD';
                                var clockInAttribute = {
                                    attribute: 'actual_clock.clock_in',
                                    action: action,
                                    to: attribute.meta.clock_in,
                                };
                                attributes.push(clockInAttribute);
                                if (attribute.meta.clock_in_action) {
                                    var clockInReason = {
                                        attribute: 'actual_clock.clock_in_action.reason',
                                        to: attribute.meta.clock_in_action.reason,
                                    }
                                    attributes.push(clockInReason);
                                }
                                if (attribute.meta.clock_out) {
                                    var clockOutAttribute = {
                                        attribute: 'actual_clock.clock_out',
                                        action: action,
                                        to: attribute.meta.clock_out,
                                    };
                                    attributes.push(clockOutAttribute);
                                    if (attribute.meta.clock_out_action) {
                                        var clockOutReason = {
                                            attribute: 'actual_clock.clock_out_action.reason',
                                            to: attribute.meta.clock_out_action.reason,
                                        }
                                        attributes.push(clockOutReason);
                                    }
                                }
                            }
                            if (attribute.meta?.job_titles?.length) {
                                for (let jobTitle of attribute.meta.job_titles) {
                                    attributes.push({
                                        attribute: 'actual_clock.job_titles',
                                        action: 'ADD',
                                        meta: jobTitle
                                    });
                                }
                            }
                            if (attribute.meta && attribute.meta.breaks && attribute.meta.breaks.length) {
                                var formattedBreaks = CTTimesheetService.formatTimeCardBreaks(attribute.meta.breaks);
                                for (var i in formattedBreaks) {
                                    var breakAttribute = {};
                                    if (formattedBreaks[i].start_time && formattedBreaks[i].end_time) {
                                        breakAttribute = {
                                            attribute: 'actual_clock.breaks',
                                            action: 'ADD',
                                            meta : formattedBreaks[i]
                                        }
                                        breakAttribute.meta['time_status'] = breakAttribute.meta['break_in_action'] && breakAttribute.meta['break_in_action']['time_status'];
                                    }
                                    else {
                                        breakAttribute = {
                                            attribute: 'actual_clock.breaks.status',
                                            action: 'UPDATE',
                                            meta : formattedBreaks[i]
                                        }
                                        breakAttribute.to = formattedBreaks[i].status;
                                    }
                                    attributes.push(breakAttribute);

                                    if (
                                        breakAttribute.meta && breakAttribute.meta.employer_ignore_reason &&
                                        breakAttribute.meta.employer_ignore_reason.code === 'PERSONAL'
                                    ) {
                                        attributes.push({
                                            attribute: 'actual_clock.breaks.status_reason',
                                            action: 'ADD',
                                            to: breakAttribute.meta.employer_ignore_reason.code,
                                            meta : formattedBreaks[i]
                                        })
                                    }
                                }
                            }
                        }
                    }

                    if (entry.source === 'TEAMHUB' && entry?.actor?.type === 'EMPLOYEE') {
                        if ($scope.date.isSameOrAfter(moment(breaksHistoryTextVersionSettings?.start_date), 'day')) {
                            attributes = attributes?.filter((attr) => {
                                return (
                                    attr.meta?.waive_status ||
                                    attr.attribute === CTTimesheetService.HISTORY_ENTRY_ATTRIBUTES.EMPLOYEE_STATUS ||
                                    (
                                        [CTTimesheetService.HISTORY_ENTRY_ATTRIBUTES.BREAK_IN_ACTION_REASON, CTTimesheetService.HISTORY_ENTRY_ATTRIBUTES.BREAK_OUT_ACTION_REASON].includes(attr.attribute) &&
                                        (
                                            CTTimesheetService.isValidBreakActionReason(attr.from) ||
                                            CTTimesheetService.isValidBreakActionReason(attr.to)
                                        )
                                    ) ||
                                    (
                                        attr.attribute === CTTimesheetService.HISTORY_ENTRY_ATTRIBUTES.BREAKS_STATUS &&
                                        CTTimesheetService.isAutomaticallyEmployeeConfirmDuePersonalReason(attr)
                                    )
                                )
                            });
                        } else {
                            attributes = []
                        }
                    }

                    entry.parsedAttributes = attributes.map((attribute) => {
                       if (['EMPLOYEE_PROTESTED', 'EMPLOYEE_APPROVED', 'EMPLOYEE_ACKNOWLEDGED'].includes(attribute.to)) {
                           entry.is_employee_message = true;
                       }

                       const msg = {};

                       const splitShiftPenaltySettings = CTTimesheetService.getSplitShiftPenaltySettings($scope.date);

                       CTTimesheetService.parseTimeCardHistoryEntry(attribute, $scope.breaksRulesSet, $scope.clockTimeStatusReasonTrackingMode, isScheduledShift, splitShiftPenaltySettings, entry.source)
                           .then(function (msgText) {
                               msg['text'] = msgText;
                               $scope.$digest();
                           });

                        return msg;

                    });

                    return entry;
                });

                allHistoryEntries.reverse();

                var historyEntriesByDate = {};
                allHistoryEntries.forEach((entry) => {
                    if (
                        entry.source === 'TEAMHUB' &&
                        entry?.actor?.type === 'EMPLOYEE' &&
                        !entry.parsedAttributes?.length
                    ) {
                        return
                    }
                    const date = moment($filter("formatDateIgnoreTimeZone")(entry.time, "YYYY-MM-DD"));
                    if (entry.attributes?.length) {
                        if (historyEntriesByDate[date]){
                            historyEntriesByDate[date].push(entry);
                        } else {
                            historyEntriesByDate[date] = [entry];
                        }
                    }
                });

                $scope.historyEntries = Object.values(historyEntriesByDate);
            };


            var parseProtests = function (protestsMessages) {
                var defer = $q.defer();

                var userToLoad = [];

                protestsMessages.forEach(function (message) {

                    var user = TSUsersService.users[message.user.id];

                    if (!user) {
                        userToLoad.push(message.user.id);
                    } else {
                        message.user = user;
                    }
                });

                if (userToLoad.length) {
                    TSUsersService.loadUsers(modalData.brand.id, userToLoad)
                        .then(function () {
                            protestsMessages.forEach(function (message) {
                                message.user = TSUsersService.users[message.user.id];
                            });

                            $scope.protestsMessages = protestsMessages;
                            defer.resolve();
                        }, function (reason) {
                            var alertOptions = {
                                title: 'Something went wrong!',
                                text: JSON.stringify(reason)
                            };

                            hAlert(
                                alertOptions
                            );

                            defer.reject();
                        });
                } else {
                    $scope.protestsMessages = protestsMessages;
                    defer.resolve();
                }

                return defer.promise;
            };

            $scope.onReasonToEditChanged = function () {
                if ($scope.editShiftForm.data.clockEditReason) {
                    $scope.editShiftForm.showReasonIsRequiredError = false;
                }
            };

            $scope.setActiveTab = function (tab) {
                $scope.activeTab = tab;
            };

            $scope.isProtestsSectionEnabled = function () {
                return (
                    $scope.timeSheeetAdjustmentSettings.employee_protest_enabled &&
                    $scope.protestsMessages && $scope.protestsMessages.length
                )
            };

            $scope.countProtests = function () {
                var numberOfProtests = 0;

                if ($scope.protestsMessages) {
                    for (var i in $scope.protestsMessages) {
                        var protest = $scope.protestsMessages[i];

                        if (protest.user.id == $scope.shift.employeeId) {
                            numberOfProtests++;
                        }
                    }
                }

                return numberOfProtests;
            };

            $scope.getTerminationDate = function () {
                var lastIndex = $scope.employee.employment_periods && $scope.employee.employment_periods.length - 1;
                if (lastIndex > -1) {
                    return $scope.employee.employment_periods[lastIndex].leave_date;
                }
            }

            $scope.isPenaltyExceptionsListDisable = function (penalty) {
                return CTTimesheetService.isPenaltyExceptionsListDisable(penalty) || !$scope.isEditable();
            };

            $scope.isUnresolved = function (penalty) {
                return CTTimesheetService.isUnresolved(penalty);
            };

            $scope.showException = function (penalty, penaltyType) {
                return CTTimesheetService.showException(penalty, penaltyType);
            };

            $scope.showSystemIgnore = function (penalty) {
                return (penalty.status === 'SYSTEM_IGNORED' && !penalty.isExceptionListDisabled);
            };


            $scope.openRemoteClockAttempts =  (employeeAttempt)=> {
                const modalData = () => {
                    return {
                        employeeAttempt: employeeAttempt,
                    };
                };
               $modal(ViewRemoteClockAttemptsModal(modalData));
            };

            $scope.isApproveClockDisabled = function () {
                return (
                    $scope.isThereOverlapping ||
                    $scope.isProcessing ||
                    $scope.countUnfixedWarnings() > 0 ||
                    $scope.editShiftForm.loadingBreaksInProgress ||
                    $scope.editShiftForm.shiftExtendedInLockedWeek() ||
                    $scope.editShiftForm.loading ||
                    $scope.editShiftForm.breaksSectionIsLoading ||
                    $scope.editShiftForm.breaksHaveWarnings() ||
                    $scope.editShiftForm.shiftExtendedInClosedPayPeriod() ||
                    $scope.hasTimesheetOfflineConflict ||
                    !$scope.editShiftForm.isNextDayWithinEmploymentPeriod() ||
                    ($scope.deletedShiftWithAutoConfirmPremium && ['OUT_OF_EMPLOYMENT_PERIOD', 'OUT_OF_LOCATION_PERIOD'].indexOf($scope.error) > -1) ||
                    ($scope.editShiftForm.isOverlappingWithOtherClocks && CTTimesheetService.getBlockOverlappingTimeCardsEnabled()) ||
                    $scope.editShiftForm.isGreaterThan24Hours ||
                    selectedWeekLockStatus === 'LOCKED' ||
                    $scope.editShiftForm.hasUnconfirmedBreak
                );
            };

            $scope.isPenaltyActionDisabled = function () {
                return (
                    $scope.shift.isExtendedFromPreviousDay ||
                    ['OUT_OF_EMPLOYMENT_PERIOD','OUT_OF_LOCATION_PERIOD'].indexOf($scope.error) > -1
                );
            };

            $scope.countUnfixedWarnings = function () {
                var count = 0;

                $scope.shift.actual_clock.penalties = $scope.shift.actual_clock.penalties || [];
                $scope.shift.actual_clock.penalties.forEach(function (penalty) {
                    if (penalty.ignore_reason && penalty.ignore_reason.code) {
                        penalty.originalIgnoreReason = penalty.originalIgnoreReason || penalty.ignore_reason.code;
                    }
                    if ($scope.isUnresolved(penalty)) {
                        count++;
                    }
                });

                if ($scope.shift.actual_clock &&
                    $scope.shift.actual_clock.call_in &&
                    $scope.shift.actual_clock.call_in.duration > 0 &&
                    $scope.isUnresolved($scope.shift.actual_clock.call_in)) {
                    count++;
                }

                $scope.shift.actual_clock.right_to_rest = $scope.shift.actual_clock.right_to_rest || [];
                $scope.shift.actual_clock.right_to_rest.forEach(function (penalty) {
                    if ($scope.isUnresolved(penalty)) {
                        count++;
                    }
                });

                return count;
            };

            $scope.refusePenalty = function (penalty, type) {
                var penaltyId = type === 'CALL_IN' ? 'CALL_IN': penalty.id;
                $scope.editShiftForm.onPenaltyStatusUpdated($scope.shift.actual_clock.id, penalty.status,'IGNORED', penaltyId);
                CTTimesheetService.refusePenalty(penalty);
            };

            $scope.confirmPenalty = function (penalty, type) {
                var penaltyId = type === 'CALL_IN' ? 'CALL_IN': penalty.id;
                $scope.editShiftForm.onPenaltyStatusUpdated($scope.shift.actual_clock.id, penalty.status,'APPROVED', penaltyId);
                CTTimesheetService.confirmPenalty(penalty);
            };

            $scope.unResolvePenalty = function (penalty, type) {
                var penaltyId = type === 'CALL_IN' ? 'CALL_IN': penalty.id;
                $scope.editShiftForm.onPenaltyStatusUpdated($scope.shift.actual_clock.id, penalty.status,'PENDING_APPROVAL', penaltyId);
                penalty.status = "PENDING_APPROVAL";
            };

            $scope.penaltyExceptionChanged = function (penalty, type) {
                var penaltyId = type === 'CALL_IN' ? 'CALL_IN': penalty.id;
                $scope.editShiftForm.onPenaltyIgnoreReasonUpdated($scope.shift.actual_clock.id, penalty.originalIgnoreReason, penalty.ignore_reason && penalty.ignore_reason.code, penalty.status, penaltyId);
            };

                var getPenaltiesPayload = function () {
                    var payload = {};

                    if ($scope.shift.actual_clock.penalties && $scope.shift.actual_clock.penalties.length) {
                        payload.penalties = [];

                        for (var i in $scope.shift.actual_clock.penalties) {
                            var penalty = getPenalty($scope.shift.actual_clock.penalties[i]);
                            payload.penalties.push(penalty);
                        }
                    }

                    if ($scope.shift.actual_clock.right_to_rest && $scope.shift.actual_clock.right_to_rest.length) {
                        payload.right_to_rest = [];

                        for (var i in $scope.shift.actual_clock.right_to_rest) {
                            var penalty = getPenalty($scope.shift.actual_clock.right_to_rest[i]);
                            payload.right_to_rest.push(penalty);
                        }
                    }

                    if ($scope.shift.actual_clock.call_in && $scope.shift.actual_clock.call_in.duration > 0) {
                        payload.call_in = getPenalty($scope.shift.actual_clock.call_in);
                    }

                    return payload;
                };

                var getPenalty = function(penaltyDetails) {
                    var penalty = {
                        status: penaltyDetails.status,
                    };
                    if (penaltyDetails.id) {
                        penalty.id = penaltyDetails.id;
                    }

                    if (penaltyDetails.status === fairSchedulingService.PENALTY_STATUS.IGNORED) {
                        penalty.ignore_reason = {
                            id: penaltyDetails.ignore_reason.id
                        };
                    } else if (
                        penaltyDetails.status === fairSchedulingService.PENALTY_STATUS.SYSTEM_IGNORED && (
                            [
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.NEW_HIRE,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.FWW_24_HOUR_WINDOW,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.UNASSIGNED_SHIFT_PICKUP,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.INAPPLICABLE_SCHEDULED_RIGHT_TO_REST,
                            ].includes(penaltyDetails.system_ignore_eligibility_type)
                        )
                    ) {
                        penalty.ignore_reason = {
                            id: penaltyDetails.ignore_reason.id,
                            type: penaltyDetails.system_ignore_eligibility_type
                        };
                    } else if (penaltyDetails['ignore_reason'] && ['EMPLOYEE_REQUESTED', 'NON_COVERED'].indexOf(penaltyDetails['ignore_reason']['type']) > -1) {
                        penalty.ignore_reason = {
                            id: penaltyDetails.ignore_reason.id,
                            type: penaltyDetails['ignore_reason']['type']
                        };
                    }

                    return penalty;
                }

                var updateCallInIgnoreReason = function () {
                    if ($scope.shift.actual_clock.call_in &&
                        $scope.shift.actual_clock.call_in.duration > 0 &&
                        $scope.shift.actual_clock.call_in.status === 'IGNORED' &&
                        $scope.shift.actual_clock.call_in.ignore_reason) {

                        var ignoreReasonDetails = $scope.callInIgnoreReasons.find(function (reason) {
                            return reason.id === $scope.shift.actual_clock.call_in.ignore_reason.id;
                        })
                        if (ignoreReasonDetails) {
                            $scope.shift.actual_clock.call_in.ignore_reason = ignoreReasonDetails;
                        }

                    }

                }

            var updateClockData = function (clock) {

                $scope.shift = clock;
                updateCallInIgnoreReason($scope.shift.actual_clock.call_in);
                attachPenaltiesDetails();
            };

            var getNewPenalties = function (clock) {
                var newPenalties = clock.actual_clock.penalties || [];
                var newRightToRestPenalties = clock.actual_clock.right_to_rest || [];
                var newCallInPenalty = clock.actual_clock.call_in || {};

                return {
                    penalties: newPenalties,
                    right_to_rest: newRightToRestPenalties,
                    call_in: newCallInPenalty
                }
            };

            var hasNewPenalties = function (clock) {
                var penaltiesData = getNewPenalties(clock);
                var newPenalties = penaltiesData.penalties;
                var newRightToRestPenalties = penaltiesData.right_to_rest;
                var newCallInPenalty = penaltiesData.call_in;

                if (
                    $scope.shift.actual_clock.penalties.length !== newPenalties.length ||
                    $scope.shift.actual_clock.right_to_rest.length !== newRightToRestPenalties.length
                ) {
                    return true
                }

                for (var i in $scope.shift.actual_clock.penalties) {
                    var item = _.find(newPenalties, {id: $scope.shift.actual_clock.penalties[i].id});

                    if (!item || item.status !== $scope.shift.actual_clock.penalties[i].status) {
                        return true;
                    }
                }

                for (var i in $scope.shift.actual_clock.right_to_rest) {
                    var item = _.find(newRightToRestPenalties, {id: $scope.shift.actual_clock.right_to_rest[i].id});

                    if (!item || item.status !== $scope.shift.actual_clock.right_to_rest[i].status) {
                        return true;
                    }
                }
                var isCallInEmpty = Object.keys($scope.shift.actual_clock.call_in).length === 0;
                var isNewCallInPenaltyEmpty = Object.keys(newCallInPenalty).length === 0;

                if (
                    (isCallInEmpty && newCallInPenalty.duration > 0) ||
                    (isNewCallInPenaltyEmpty && $scope.shift.actual_clock.call_in.duration > 0) ||
                    $scope.shift.actual_clock.call_in.duration !== newCallInPenalty.duration
                ) {
                    return true;
                }

                return false;
            };

            $scope.switchEnableForm = function () {
                $scope.shift.is_editable = true;

                if (
                    $scope.timeSheeetAdjustmentSettings.employee_protest_enabled &&
                    $scope.timeSheeetAdjustmentSettings.is_clock_edit_reason_enabled
                ) {
                    $scope.editShiftForm.toggleTimeCardChanged();
                }
            };

            $scope.approve = function (mode) {
                if(
                    modalData.brand.services.indexOf('TIPS_DISTRIBUTION') > -1 &&
                    $scope.shift.is_tipped &&
                    $scope.editShiftForm.data.position.id !== $scope.shift.actual_clock.position.id &&
                    !$scope.editShiftForm.data.position.position_settings['is_tipped']
                ) {
                    hConfirm({
                        title: $filter("translate")("Confirm Edit"),
                        text: $filter("translate")("The applied edit will remove the distributed tips for ") +
                                                    $scope.employee.first_name + " " + $scope.employee.last_name +
                                                    $filter("translate")(", confirm to proceed."),
                        confirmButton: $filter("translate")("Confirm"),
                        cancelButton: $filter("translate")("Cancel"),
                        callback: function (confirmed) {
                            if (confirmed) {
                                updateForm(true, mode);
                            }
                        }
                    });
                } else {
                    updateForm(false, mode);
                }
            };

            var updateForm = function (removeTips, mode) {
                $scope.isProcessing = true;
                $scope.error = null;
                var updatePromise = {};

                if (mode === 'UPDATE_TIPS_ONLY') {
                    updatePromise['updateTips'] = $scope.editShiftForm.updateExtendedTips(removeTips);
                } else {
                    var penaltiesData = getPenaltiesPayload();
                    updatePromise['save'] = $scope.editShiftForm.save(removeTips, penaltiesData);
                }

                $q.all(updatePromise)
                    .then(function (res) {
                        $scope.isProcessing = false;
                        $scope.editShiftForm.resetTimeCardChanged();

                        var data = CTTimesheetService.getData();
                        var extendedClockIndex = _.findIndex(data.clocks, function (clock) {
                            return (clock.actual_clock.id === $scope.shift.actual_clock.id && clock.isExtendedFromPreviousDay)
                        });

                        if (extendedClockIndex > -1 && mode !== 'UPDATE_TIPS_ONLY') {
                            data.clocks.splice(extendedClockIndex, 1);
                        }

                        var promise = onSave(res['save'], mode === 'UPDATE_TIPS_ONLY');
                        if (promise) {
                            promise
                                .then(function () {
                                    var clock = data.clocks.find(function (clock) {
                                        return clock.actual_clock.id === $scope.shift.actual_clock.id
                                    });
                                    if (hasNewPenalties(clock)) {
                                        updateClockData(clock);
                                        $scope.editShiftForm.updateShift($scope.shift);
                                        $scope.error = "PENALTIES_UPDATED";
                                        $scope.setActiveTab('WARNINGS')
                                    } else {
                                        actualClockTimeManagementService.checkForTimeCardActionViolations(res['save'].warnings, modalData.employee.id, () => {
                                            $scope.hideModal();
                                        });
                                    }
                                });
                        } else {
                            $scope.hideModal();
                        }
                    }, function (err) {
                        $scope.isProcessing = false;

                        //in case it's a front-end validation error, then most likely it will be in details page
                        //switch the view to details page
                        if (err && err.type === "FE_VALIDATION_ERROR") {
                            $scope.setActiveTab("DETAILS");
                        } else if (err && err.data && err.data.errors && err && err.data && err.data.errors) {
                            var errors = err.data.errors;
                            if ([
                                    //Errors related to time entry
                                    "CLOCK_ENTRY_ALREADY_APPROVED",
                                    "CLOCK_ENTRY_DELETED",
                                    "SHIFT_NOT_FOUND",
                                    //Errors related to paysheet
                                    "PAYSHEET_CLOSED",
                                    //Un-Authorized
                                    "UNAUTHORIZED_CATEGORY",
                                    //errors related to breaks
                                    "BREAK_IS_DELETED",
                                    "BREAK_IS_ADDED_TO_PAY_TIME",
                                    "BREAK_IS_IGNORED",
                                    //general excecptions
                                    "OPTIMISTIC_LOCK_EXCEPTION",
                                ].indexOf(errors[0].code) > -1) {
                                if (errors[0].code === "UNAUTHORIZED_CATEGORY") {
                                    $scope.error = "UNAUTHORIZED_CATEGORY";
                                } else {
                                    $scope.error = "UPDATED_TIMECARD";
                                }
                            } else if (errors[0].code === 'OVERLAPPING_TIMECARDS') {
                                $scope.hasOverlappingError = true;
                            } else if (errors[0].detail?.[ACTUAL_CLOCK_ACTION_VIOLATION_TYPE.RIGHT_TO_REST]) {
                                actualClockTimeManagementService.checkForTimeCardActionViolations(errors[0].detail, modalData.employee.id);
                            } else {
                                console.error("error while trying to process your request, please send the following error to our tech team!", err);
                            }
                        } else {
                            console.error("error while trying to process your request, please send the following error to our tech team!", err);
                        }

                        setTimeout(function () {
                            $scope.$digest();
                        }, 1);
                    });
            };

                var disablePenaltyExceptionsList = function (penalty) {
                    return (
                        penalty.ignore_reason &&
                        (
                            [
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.VOLUNTARY_STANDBY_LIST,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.NEW_HIRE,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.NON_COVERED,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.EMPLOYEE_REQUESTED,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.FWW_24_HOUR_WINDOW,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.MASS_COMMUNICATION,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.UNASSIGNED_SHIFT_PICKUP,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.INAPPLICABLE_SCHEDULED_RIGHT_TO_REST,
                            ].includes(penalty.ignore_reason.type)
                        )
                    );
                };

            var attachPenaltiesDetails = function () {
                var defer = $q.defer();

                if (
                    ($scope.shift.actual_clock && $scope.shift.actual_clock.penalties && $scope.shift.actual_clock.penalties.length) ||
                    ($scope.shift.actual_clock.right_to_rest && $scope.shift.actual_clock.right_to_rest && $scope.shift.actual_clock.right_to_rest.length)
                ) {
                    fairSchedulingService.getPenaltiesRules()
                        .then(function (rules) {
                            for (var i in $scope.shift.actual_clock.penalties) {
                                var penalty = $scope.shift.actual_clock.penalties[i];
                                var rule = rules.find(function (item) { return item.id === penalty.rule_id; });
                                penalty.isExceptionListDisabled = disablePenaltyExceptionsList(penalty);

                                if (rule) {
                                    penalty.ruleDetails = rule;
                                    penalty.penaltyDetails = fairSchedulingService.getPenaltyDetails(penalty, rule);
                                } else {
                                    console.error("can't find rule", penalty.rule_id)
                                }
                            }

                            for (var i in $scope.shift.actual_clock.right_to_rest) {
                                var penalty = $scope.shift.actual_clock.right_to_rest[i];
                                var rule = rules.find(function (item) { return item.id === penalty.rule_id; });
                                penalty.isExceptionListDisabled = disablePenaltyExceptionsList(penalty);

                                if (rule) {
                                    penalty.ruleDetails = rule;
                                    penalty.penaltyDetails = fairSchedulingService.getPenaltyDetails(penalty, rule);
                                } else {
                                    console.error("can't find rule", penalty.rule_id)
                                }
                            }

                            defer.resolve();
                        })
                        .catch(function (err) {
                            console.error(err);
                            defer.reject(err);
                        });
                } else {
                    defer.resolve();
                }

                return defer.promise;
            };

            $scope.isPunchPhotoWarningShown = function () {
                return (
                    $scope.facialRecognitionEnabled &&
                    $scope.employeeRecognitionAttempts &&
                    $scope.employeeRecognitionAttempts.length &&
                    $scope.employeeRecognitionAttempts.findIndex(function (attempt) {
                        return attempt.is_employee_ignored && attempt.type === 'FACIAL';
                    }) > -1
                );
            };

            var setTimecardAttemptDetails = function (attempts) {
                for (var i in attempts) {
                    setTimeCardAttemptUser(attempts[i]);
                    if (attempts[i].blocker_mode === 'BLOCKER') {
                        if ($scope.isAttemptByManagerAction(attempts[i])) {
                            attempts[i].isBlockerConfirmation = attempts[i-1] && attempts[i-1].confidence_type === 'LOW';
                        }

                        attempts[i].showUnsuccessfulConfirmationMessage = attempts[i].confidence_type === 'LOW';
                    }
                    attempts[i].attemptText = getTimeCardAttemptAction(attempts[i]);
                }
            }

            $scope.isAttemptByManagerAction = function (attempt) {
                return attempt.employer_id;
            }

            var setTimeCardAttemptUser = function (attempt) {
                if (attempt.employer_id) {
                    TSUsersService.getUserInfo(modalData.brand.id, attempt.employer_id)
                        .then(function (manager) {
                            attempt.user = manager.first_name + " " + manager.last_name;
                        });
                } else {
                    attempt.user = $scope.employee.first_name + " " + $scope.employee.last_name;
                }
            }

            var getTimeCardAttemptAction = function (attempt) {
                return CTTimesheetService.getTimeCardAttemptActionText(attempt, $scope.shift);
            }

            $scope.prepareEmployeeAttemptTooltip = function (clockLoginSettings, employeeAttempt) {
                if ($scope.facialRecognitionEnabled) {
                    if (employeeAttempt.is_employee_ignored) {
                        return $filter("translate")("Revoked!");
                    } else if (clockLoginSettings.enable_recognition_warnings && employeeAttempt.confidence_type === 'LOW') {
                        return $filter("translate")("View Photo: Attention Needed!");
                    } else {
                        return $filter("translate")("View Photo");
                    }
                } else {
                    return $filter("translate")("You cannot view photos");
                }
            };

            $scope.getFormattedChangeValue = function (value) {
                return CTTimesheetService.getPremiumFormattedChangeValue(value);
            };

            $scope.isEditable = function () {
                return !$scope.shift || ($scope.shift.is_editable && !$scope.shift.isViewOnly);
            };

            $scope.isRestoreButtonShown = function () {
                return (
                    $scope.shift &&
                    $scope.shift.status === 'DELETED' &&
                    !$scope.shift.isExtendedFromPreviousDay &&
                    !$scope.shift.isViewOnly
                );
            };

            $scope.isRTRPenaltyExceptionDisabled = (penalty) => {
                return (
                    !$scope.editShiftForm.isFormEditable() ||
                    !$scope.canResolveRTRPenaltyAsException ||
                    CTTimesheetService.isPenaltyExceptionsListDisable(penalty)
                );
            };

            //Trigger the re-load call
            $scope.reloadTimesheet = function () {
                onReload();
                $scope.hideModal();
            };

            //Hide modal
            $scope.hideModal = function () {
                CTTimesheetService.resetClockRightToRestAudit();
                $scope.$hide();

                setTimeout(function () {
                    $scope.$digest();
                }, 1);
            };

            var mapPenaltiesReasons = function (penalties, premiumPayIgnoreReasons) {
                for (var i in penalties) {
                    var penalty = penalties[i];
                    if (['IGNORED', 'SYSTEM_IGNORED'].indexOf(penalty['status']) > -1 && penalty['ignore_reason']) {
                        var ignoreReason = _.findWhere(premiumPayIgnoreReasons, {id: penalty['ignore_reason'].id});
                        if (!ignoreReason) {
                            ignoreReason = _.findWhere($scope.finalFWWIgnoreReasons, {id: penalty['ignore_reason'].id});
                        }
                        penalty['ignore_reason']['name'] = ignoreReason['name'];
                        penalty['ignore_reason']['status'] = ignoreReason['status'];
                    }
                }
            };

                $scope.onOptionSelect = function (target) {
                    return function (option) {
                        var metaObj = {};
                        if (option.next_day) {
                            metaObj.appendText = $filter('translate')('Next Day');
                            metaObj.prependIcon = 'next-day-icon';
                        } else {
                            metaObj.appendText = '';
                            metaObj.prependIcon = '';
                        }

                        $scope.shift.warnings[target + '_meta'] = metaObj;
                    }
                };

                $scope.onFromTimeChange = function (value) {
                    if (value) {
                        var to = clockTimeMoment['clockOut'] || $scope.businessDayLimits.closeTime;
                        $scope.endTimeOptions = hTimePickerUtils.getIntervalOptions({
                            from: value,
                            to: to,
                            withInfo: true,
                            minutesPeriod: 15,
                            includeFrom: false,
                            includeTo: true,
                            closeTimeWithoutExtension: $scope.businessDayLimits.closeTimeWithoutExtension
                        })
                    } else {
                        $scope.endTimeOptions = [];
                    }
                };

            const mapPenaltiesConsentDetails = (penalties, consents, rightToRestPenalty) => {
                for (const i in penalties) {
                    const penalty = penalties[i];
                    let premiumKey = 'penalty';

                    if (rightToRestPenalty) {
                        premiumKey = 'right_to_rest';
                    }

                    $scope.mappedPenalties[premiumKey] ??= {};
                    $scope.mappedPenalties[premiumKey][penalty.id] = {};

                    if (rightToRestPenalty) {
                        const rightToRestConsents = consents.filter(consent => consent?.premiums?.right_to_rest?.length);
                        rightToRestConsents.sort((consent1, consent2) => new Date(consent2.final_status_date) - new Date(consent1.final_status_date));

                        if (rightToRestConsents[0]) {
                            $scope.mappedPenalties[premiumKey][penalty.id].consents ??= [];
                            $scope.mappedPenalties[premiumKey][penalty.id].consents.push({
                                consent_status: rightToRestConsents[0].status,
                                consented_on : rightToRestConsents[0].final_status_date,
                                request_reason : rightToRestConsents[0].requested_reason,
                                consent_source : rightToRestConsents[0].actor_source,
                                isClockOutConsent: rightToRestConsents[0].isUnscheduled && rightToRestConsents[0].status === 'SYSTEM_REJECTED',
                            });
                        }
                    } else {
                        for (const j in consents) {
                            const consent = consents[j];

                            const consentPenalties = consent?.premiums?.penalties;
                            const consentPenalty = consentPenalties?.find(consentPenalty => consentPenalty.id === penalty.id);

                            if (consentPenalty) {
                                $scope.mappedPenalties[premiumKey][penalty.id].consents ??= [];
                                $scope.mappedPenalties[premiumKey][penalty.id].consents.push({
                                    consent_status: consent.status,
                                    consented_on : consent.final_status_date,
                                    request_reason : consent.requested_reason,
                                    consent_source : consent.actor_source,
                                    isClockOutConsent: consent.isUnscheduled && consent.status === 'SYSTEM_REJECTED',
                                });
                            }
                        }
                    }
                }
            };

            var attachConsentPenaltyDetails = function () {
                var clockId = modalData.shift.actual_clock && modalData.shift.actual_clock.id;
                var shiftId = modalData.shift && modalData.shift.scheduled_shift && modalData.shift.scheduled_shift.id;
                var isScheduled = !!shiftId;

                CTTimesheetService
                    .getEmployeeClockConsentDetails(modalData.brand.id, clockId, shiftId, isScheduled)
                    .then(function (consents) {
                        consents.sort(function (a, b) {
                            return new Date(a.final_status_date) - new Date(b.final_status_date)
                        })
                        mapPenaltiesConsentDetails($scope.shift.actual_clock.penalties, consents);
                        mapPenaltiesConsentDetails($scope.shift.actual_clock.right_to_rest, consents, true);
                    });
            };

            const setBrandJobTitles = async () => {
                const isJobTitleSkillLevelServiceEnabled = await brandServices.check(brandServices.SERVICES.JOB_TITLE_SKILL_LEVEL, modalData.brand.id);
                if (isJobTitleSkillLevelServiceEnabled) {
                    const brandJobTitles = await BrandAPI.getBrandJobTitlesWithRestrictedPositions(modalData.brand.id);
                    jobTitlesDataService.setBrandJobTitles(brandJobTitles.job_titles || []);
                }
            }

            //Init
            (function () {
                $scope.shift.actual_clock.penalties = $scope.shift.actual_clock.penalties || [];
                $scope.shift.actual_clock.right_to_rest = $scope.shift.actual_clock.right_to_rest || [];
                $scope.mappedPenalties = {right_to_rest: {}, penalty: {}};
                $scope.callInIgnoreReasons = [];
                var hasAutoConfirmPremium = $scope.shift.actual_clock.penalties.find(function(penalty) {
                    return penalty.status == 'SYSTEM_APPROVED';
                });

                $scope.deletedShiftWithAutoConfirmPremium = ($scope.shift.category == 'SCHEDULED_DELETED') && hasAutoConfirmPremium;

                var promisesToLoad = {};
                var requestDate = modalData.shift.isExtendedFromPreviousDay ? $scope.date.clone().subtract(1, 'days') : $scope.date;

                promisesToLoad['card_history'] = PerformanceAggregatorAPI.getEmployerTimeCardHistory(modalData.brand.id, modalData.employee.id, modalData.shift.actual_clock.id, requestDate.format("YYYY-MM-DD"));
                promisesToLoad['ignore_reasons'] = TimesheetSettingsService.getPremiumPayIgnoreReasons();
                promisesToLoad['final_fww_reasons'] = TimesheetSettingsService.getFinalFWWExceptions();
                if ($scope.activeCallInsSettings && $scope.activeCallInsSettings !== "NONE") {
                    promisesToLoad['call_in_ignore_reasons'] = TimesheetSettingsService.getCallInIgnoreReasons();
                }

                if ($scope.timeSheeetAdjustmentSettings.employee_protest_enabled) {
                    promisesToLoad['protests_messages'] = PerformanceAggregatorAPI.getClockProtestsMessages(modalData.brand.id, modalData.employee.id, modalData.shift.actual_clock.id, requestDate.format("YYYY-MM-DD"));
                }

                if ($scope.clockLoginSettings['allow_punch_photo_management']) {
                    promisesToLoad['brand_login_types_settings'] = TimesheetSettingsService.getClockLoginSettings();
                }

                promisesToLoad["set_brand_job_titles"] = setBrandJobTitles();

                if ($scope.shift.actual_clock.right_to_rest.length) {
                    var clockId = modalData.shift.actual_clock && modalData.shift.actual_clock.id;
                    var shiftId = modalData.shift && modalData.shift.scheduled_shift && modalData.shift.scheduled_shift.id;
                    var isScheduled = $scope.shift.actual_clock.right_to_rest[0].source === 'FORECAST';
                    var rtrId = $scope.shift.actual_clock.right_to_rest[0].id;

                    promisesToLoad['clock_right_to_rest_audit'] = CTTimesheetService.getClockRightToRestAudit(modalData.brand.id, modalData.employee.id, rtrId, clockId, shiftId, isScheduled);
                }

                promisesToLoad['policyParser'] = userPermissions.getBrandPolicy(modalData.brand.id);
                $scope.loadingTimeCard = true;

                var businessDay = TeamScheduleService.getBusinessDay();
                $scope.businessDayLimits = businessDayUtils.getBusinessDayLimits(businessDay, formattedShiftDate);
                var selectedWeekLockStatusDetails = CTTimesheetService.getTimesheetLockStatuses('CURRENT_WEEK');
                selectedWeekLockStatus = selectedWeekLockStatusDetails && selectedWeekLockStatusDetails.isLocked ? 'LOCKED' : 'UNLOCKED';

                $q.all(promisesToLoad)
                    .then((res) => {
                        $scope.currency = "$";
                        var premiumPayIgnoreReasons = angular.copy(res['ignore_reasons'] && res['ignore_reasons'].error_reasons) || [];
                        $scope.premiumPayIgnoreReasons = _.filter(premiumPayIgnoreReasons, {status: 'ACTIVE'});
                        var finalFWWIgnoreReasons = angular.copy(res['final_fww_reasons'] && res['final_fww_reasons'].error_reasons) || [];
                        $scope.finalFWWIgnoreReasons = _.filter(finalFWWIgnoreReasons, {status: 'ACTIVE'});

                        if (res['clock_right_to_rest_audit']) {
                            $scope.shift.actual_clock.right_to_rest[0].clock_source = res['clock_right_to_rest_audit'].clock_source;
                        }

                        if (res['call_in_ignore_reasons']) {
                            var callInIgnoreReasons = angular.copy(res['call_in_ignore_reasons'] && res['call_in_ignore_reasons'].error_reasons) || [];
                            $scope.callInIgnoreReasons = callInIgnoreReasons.filter(function (reason) {
                                return (reason.status == 'ACTIVE') && (reason.call_in_type === $scope.activeCallInsSettings);
                            });
                        }

                        parseHistory(res.card_history.history);
                        var canViewEmployeesPunchPhoto = res['policyParser'].has(userPermissions.PERMISSIONS.VIEW_EMPLOYEES_PUNCH_PHOTOS);
                        $scope.canResolveRTRPenaltyAsException = res['policyParser'].has(userPermissions.PERMISSIONS.RESOLVE_RTR_PENALTY_AS_EXCEPTION);

                        var promises = {};
                        promises['penaltiesDetails'] = attachPenaltiesDetails();
                        var brandLoginTypesSettings = res['brand_login_types_settings'];

                        promises['recognitionAttempts'] = RecognitionAPI.getEmployeeTimeCardAttempts(modalData.brand.id, modalData.employee.id, modalData.shift.actual_clock.id);


                        attachConsentPenaltyDetails();

                        $q.all(promises)
                            .then(function (result) {
                                if (result.recognitionAttempts) {
                                    $scope.employeeRecognitionAttempts = result['recognitionAttempts'].attempts;

                                    setTimecardAttemptDetails($scope.employeeRecognitionAttempts);

                                    $scope.facialRecognitionEnabled = canViewEmployeesPunchPhoto
                                        && $scope.clockLoginSettings['allow_punch_photo_management']
                                        && (brandLoginTypesSettings.employee_recognition_type === "FACIAL"
                                            || brandLoginTypesSettings.employer_approval_recognition_type === "FACIAL");
                                }

                                mapPenaltiesReasons($scope.shift.actual_clock.penalties, premiumPayIgnoreReasons);
                                mapPenaltiesReasons($scope.shift.actual_clock.right_to_rest, premiumPayIgnoreReasons);
                            })
                            .finally(function () {
                                if (res.protests_messages) {
                                    parseProtests(res.protests_messages)
                                        .finally(function () {
                                            $scope.loadingTimeCard = false;
                                            $scope.$digest();
                                        });
                                } else {
                                    $scope.loadingTimeCard = false;
                                    $scope.$digest();
                                }
                            });

                    }, function (err) {
                        var alertOptions = {
                            title: 'Something went wrong!',
                            text: JSON.stringify(err)
                        };

                        hAlert(
                            alertOptions
                        );
                    });
            })();
        }]);

})(angular);
